import { createContext, RefObject } from 'react';

interface LightChatSideContextValue {
  containerRef: RefObject<HTMLElement>;
}

export const LightChatSideContext = createContext<LightChatSideContextValue | null>(null);
